var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c('navbar'),_c('div',{staticClass:"app-body"},[_c('sidebar'),_c('main',{staticClass:"view-x mt-3",attrs:{"role":"main"}},[_c('router-view')],1),_c('asidebar')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }